export const mfeEndpointNames = {
  PAYMENT_PAGE: '@blaze/mfe-payment-page',
  TAXES_PAGE: '@blaze/mfe-taxes-page',
  COMPLIANCE_PAGE: '@blaze/mfe-compliance-page',
  FEES_PAGE: '@blaze/mfe-fees-page',
}

const importMfe = (endPointName) => {
  const overrideEndPointName = localStorage.getItem(endPointName)

  return window.System.import(overrideEndPointName || endPointName)
}

/**
 * In this codebase, `System` is inaccessible in React components so it is attached to `window` in `public/index.html`.
 */
export const mfeConfigs = {
  LOAD_PAYMENT_PAGE: () => importMfe(mfeEndpointNames.PAYMENT_PAGE),
  LOAD_TAXES_PAGE: () => importMfe(mfeEndpointNames.TAXES_PAGE),
  LOAD_COMPLIANCE_PAGE: () => importMfe(mfeEndpointNames.COMPLIANCE_PAGE),
  LOAD_FEES_PAGE: () => importMfe(mfeEndpointNames.FEES_PAGE),
}



// WEBPACK FOOTER //
// ./src/utils/mfe.js